import React, { useEffect } from 'react';

import TestDrive from '../../components/TestDrive';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import {
  fetchInfoFromVersionColor,
  fetchTestDriveInfoRequest,
  requestTestDriveRequest,
  requestTestDriveReset,
} from '../../actions';

const TestDriveContainer = () => {
  const dispatch = useDispatch();
  const { version, tipo, modelo, anio } = useParams();
  const { logoUrl, car, isLoading, testDriveInfo } = useSelector(state => ({
    logoUrl: state.personalization.data?.logoUrl,
    car: state.personalization.data,
    isLoading: state.personalization.isLoading,
    testDriveInfo: state.testDrive,
    isReady: state.personalization.isReady,
  }));

  useEffect(() => {
    dispatch(fetchTestDriveInfoRequest());
  }, [dispatch]);

  useEffect(() => {
    return () => dispatch(requestTestDriveReset());
  }, [dispatch]);

  const requestTestDrive = testDrive =>
    dispatch(requestTestDriveRequest(testDrive));

  useEffect(() => {
    const carCode = car?.codigo;
    if (carCode === version) return;
    dispatch(fetchInfoFromVersionColor(tipo, modelo, version, anio));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <TestDrive
      logoUrl={logoUrl}
      car={car}
      isLoading={isLoading || testDriveInfo?.isLoading}
      testDriveInfo={testDriveInfo}
      requestTestDrive={requestTestDrive}
    />
  );
};

export default TestDriveContainer;
